import { render } from "./UtilityBlock.vue?vue&type=template&id=4d3683b4&scoped=true"
import script from "./UtilityBlock.vue?vue&type=script&lang=js"
export * from "./UtilityBlock.vue?vue&type=script&lang=js"

import "./UtilityBlock.vue?vue&type=style&index=0&id=4d3683b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3683b4"]])

export default __exports__